import * as yup from 'yup';

export const addressSchema = yup.object({
  address: yup.string().required('Address is required'),
  suburb: yup.string().required('Suburb is required'),
  state: yup.string().required('State is required'),
  postcode: yup.string().required('Postcode is required'),
});

export const editProfileSchema = yup.object({
  name: yup.string().required('Name is required'),
  email: yup.string().email('Invalid email').required('Email is required'),
  contact: yup.object({
    address: addressSchema,
    phone: yup.string().optional(),
  }),
});
